import {RepositoryFactory} from "@/repository/RepositoryFactory";

const ForecastRepository = RepositoryFactory.get('forecast')

export default {
  state:{
    forecasts:[],
  },
  mutations: {
    SET_FORECAST: (state, data) => {
      state.forecasts = data
    }
  },
  getters: {
    forecasts: state => state.forecasts,
  },
  actions:{
    async fetchAllForecasts({commit}, { filterQuery } ){
      const { data } = (await ForecastRepository.getForecastList(filterQuery)).data
      const arr = Object.entries(data)
      const formatted_arr = []
      arr.forEach((x) => {
        formatted_arr.push(x[x.length - 1])
      })
      commit('SET_FORECAST', formatted_arr)
    }
  }
}
